import templateUrl from 'emun.blog/blog-banner.htm'
import controller from 'emun.blog/blog-banner.controller'

let BlogBanner = {
    bindings: {
		view: '@',
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default BlogBanner;